import * as React from "react";
import { Table } from "semantic-ui-react";

interface Props {
    notes: string[];
}

const PpqReviewNotes: React.FunctionComponent<Props> = (props) => {
    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>PPQ Review Notes</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {props.notes.map((notes, index) => (
                    <Table.Row key={index}>
                        <Table.Cell>{notes}</Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

export { PpqReviewNotes };
